import { render, staticRenderFns } from "./WechatMsgDetail.vue?vue&type=template&id=530f097b&scoped=true&"
import script from "./WechatMsgDetail.vue?vue&type=script&lang=js&"
export * from "./WechatMsgDetail.vue?vue&type=script&lang=js&"
import style0 from "./WechatMsgDetail.vue?vue&type=style&index=0&id=530f097b&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "530f097b",
  null
  
)

export default component.exports